import React from "react";
import { SearchForm } from "./searchForm"
import BranchList from "./branchList"
const DataBranch = (): JSX.Element => {
    return (
        <>
            <SearchForm/>
            <BranchList/>
        </>

    )
}
export default DataBranch